import { FileAttachmentDTO } from "./../file-attachment-dto";

export class AdHocInstructionDTO {
    public units: string = "";
    public issuedFrom: Date | string = new Date().toISOString().slice(0,10);
    public issuedTo: Date | string | null = "";
    public dateComment: string = "";
    public subject: string = "";
    public details: string = "";
    public files: FileAttachmentDTO[] = [];
    public status: string ="";
    public isArchived: boolean = false;
}
